import { useContext, useState } from "react"
import { CartContext } from '../../../features/cartContext/CartContext'
import { Link, useLocation, useNavigate } from "react-router-dom";

const Approved = () => {

    const navigate = useNavigate()

    const cart = useContext(CartContext)

    cart.formatCart()

    const { state } = useLocation();
    let { confirmationNumber } = state; // Read values passed on state

    var content = confirmationNumber ?
        (
            <section class="bg-white py-8 antialiased dark:bg-gray-900 md:py-16">
                <div class="mx-auto max-w-2xl px-4 2xl:px-0">

                    <div class="flex items-center justify-center w-20 h-20 mx-auto mb-6 bg-green-100 rounded-full dark:bg-green-700">
                        <svg class="h-12 w-12 text-green-600 dark:text-green-100" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"></path>
                        </svg>
                    </div>

                    <h2 class="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl mb-2">Thanks for your order!</h2>
                    <p class="text-gray-500 dark:text-gray-400 mb-6 md:mb-8">Your order <a href="#" class="font-medium text-gray-900 dark:text-white hover:underline">#{confirmationNumber}</a> will be processed within 24 hours during working days. We will notify you by email once your order has been shipped.
                        If you have any questions or need further assistance, feel free to contact us at: megenagamart@gmail.com
                    </p>
                    <div class="space-y-4 sm:space-y-2 rounded-lg border border-gray-100 bg-gray-50 p-6 dark:border-gray-700 dark:bg-gray-800 mb-6 md:mb-8">
                        <dl class="sm:flex items-center justify-between gap-4">
                            <dt class="font-normal mb-1 sm:mb-0 text-gray-500 dark:text-gray-400">Date</dt>
                            <dd class="font-medium text-gray-900 dark:text-white sm:text-end">{
                                new Intl.DateTimeFormat('en-GB', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric'
                                }).format(new Date())
                            }</dd>
                        </dl>
                        <dl class="sm:flex items-center justify-between gap-4">
                            <dt class="font-normal mb-1 sm:mb-0 text-gray-500 dark:text-gray-400">Payment Method</dt>
                            <dd class="font-medium text-gray-900 dark:text-white sm:text-end">PayPal</dd>
                        </dl>
                        <dl class="sm:flex items-center justify-between gap-4">
                            <dt class="font-normal mb-1 sm:mb-0 text-gray-500 dark:text-gray-400">Confirmation Nubmer</dt>
                            <dd class="font-medium text-gray-900 dark:text-white sm:text-end">{confirmationNumber} </dd>
                        </dl>
                    </div>
                    <div class="flex items-center space-x-4">
                        {/* <a href="#" class="text-black bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800">Track your order</a> */}
                        <Link to={"/OnlineOrdering"} class="py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
                            Return to shopping
                        </Link>
                    </div>
                </div>
            </section>
        ) :
        (navigate('/OnlineOrdering'))

    return content
}

export default Approved